import { Component } from '@angular/core';

@Component({
  selector: 'wun-editorials-icon',
  standalone: true,
  imports: [],
  templateUrl: './editorials-icon.component.svg',
  styleUrl: './editorials-icon.component.scss'
})
export class EditorialsIconComponent {

}
